var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("\n    mdi-block-helper\n  ")]),_c('p',[_vm._v(_vm._s(_vm.emptyText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }